(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-mix-match-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const ddMmSyncFns = new WeakMap();
    const ddMmIntervals = new WeakMap();

    function refreshAllDdMixMatchSections() {
      document.querySelectorAll('.dd-mm-section').forEach((el) => {
        const fn = ddMmSyncFns.get(el);
        if (typeof fn === 'function') fn();
      });
    }

    function moveSocialProof(root) {
      var sp = root.querySelector('.dd-pv2-featured');
      var atcBadges = root.querySelector('.dd-mm-atc-badges');
      var leftCol = root.querySelector('.dd-mm-left');
      if (!sp || !atcBadges || !leftCol) return;
      if (window.innerWidth <= 980) {
        if (atcBadges.nextElementSibling !== sp) {
          atcBadges.insertAdjacentElement('afterend', sp);
        }
      } else {
        if (sp.parentElement !== leftCol) {
          leftCol.appendChild(sp);
        }
      }
    }

    var ddMmSpResizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(ddMmSpResizeTimer);
      ddMmSpResizeTimer = setTimeout(function () {
        document.querySelectorAll('.dd-mm-section').forEach(moveSocialProof);
      }, 100);
    });

    function initDdMixMatch(root) {
      if (!root || root.dataset.ddMmInited === 'true') return;
      root.dataset.ddMmInited = 'true';
      ddMmIntervals.set(root, []);

    const state = {
      mode: 'subscription',
      activeBundlePrice: 0,
      activeOnetimeBundlePrice: 0,
      activeGalleryIndex: 0,
      activeTierEl: null
    };

    let cachedMoneyCurrency = '';
    let moneyFormatter = null;

    const getPresentmentCurrencyCode = () => root.dataset.ddMmCurrency || '';

    const getMoneyFormatter = () => {
      const currencyCode = getPresentmentCurrencyCode();
      if (!currencyCode || typeof Intl === 'undefined' || !Intl.NumberFormat) return null;
      if (currencyCode !== cachedMoneyCurrency) {
        cachedMoneyCurrency = currencyCode;
        moneyFormatter = null;
        try {
          // narrowSymbol avoids "US$" vs "$" when the browser locale is not en-US (e.g. en-CA).
          moneyFormatter = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currencyCode,
            currencyDisplay: 'narrowSymbol',
          });
        } catch (e) {
          moneyFormatter = null;
        }
      }
      return moneyFormatter;
    };

    const money = (cents, options) => {
      const value = Number(cents || 0) / 100;
      const fmt = getMoneyFormatter();
      if (fmt) {
        try {
          if (options && options.noDecimals) {
            return new Intl.NumberFormat(undefined, {
              style: 'currency',
              currency: cachedMoneyCurrency || getPresentmentCurrencyCode(),
              currencyDisplay: 'narrowSymbol',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(value);
          }
          return fmt.format(value);
        } catch (e) {
          /* fall through */
        }
      }
      return value.toLocaleString(undefined, {
        minimumFractionDigits: options && options.noDecimals ? 0 : 2,
        maximumFractionDigits: options && options.noDecimals ? 0 : 2,
      });
    };

    const getShopToPresentmentMultiplier = () => 1;

    // Converts shop-base-currency cents to presentment currency and formats.
    // Use this for every price value sourced from Liquid (variant prices, bundle_price_cents, etc.).
    const moneyShop = (shopCents, options) =>
      money(Math.round(Number(shopCents || 0) * getShopToPresentmentMultiplier()), options);

    const formatStaticShopBaseMoneyLabels = () => {
      qsa('[data-dd-mm-money-cents]').forEach((el) => {
        const raw = el.getAttribute('data-dd-mm-money-cents');
        const shopCents = Number(raw != null && raw !== '' ? raw : 0);
        if (!shopCents) return;
        const noDecimals = el.getAttribute('data-dd-mm-money-no-decimals') === 'true';
        el.textContent = moneyShop(shopCents, { noDecimals });
      });
    };

    const qs = (sel) => root.querySelector(sel);
    const qsa = (sel) => Array.from(root.querySelectorAll(sel));

    const mixMatchRoot = qs('[data-dd-mm-mixmatch-root]');
    const mixMatchRowsScope = mixMatchRoot || root;
    const qsaRows = () => Array.from(mixMatchRowsScope.querySelectorAll('[data-dd-mm-row]'));

    const getLinePrice = (row) => {
      const normal = Number(row.dataset.priceNormal || 0);
      const subscription = Number(row.dataset.priceSubscription || 0);
      return state.mode === 'subscription' ? subscription : normal;
    };

    const getLineCompare = (row) => {
      const normal = Number(row.dataset.compareNormal || 0);
      const subscription = Number(row.dataset.compareSubscription || 0);
      return state.mode === 'subscription' ? subscription : normal;
    };

    // Parses "id1:Name1|id2:Name2" into { "Name1": id1, "Name2": id2 }
    const parseSellingPlans = (raw) => {
      if (!raw) return {};
      return raw.split('|').reduce((acc, pair) => {
        const colonIdx = pair.indexOf(':');
        if (colonIdx > -1) {
          const id = Number(pair.slice(0, colonIdx));
          const name = pair.slice(colonIdx + 1);
          if (id && name) acc[name] = id;
        }
        return acc;
      }, {});
    };

    const getVariantId = (row) => {
      return state.mode === 'subscription'
        ? row.dataset.variantSubscription
        : row.dataset.variantNormal;
    };

    const getTotalMixMatchQty = () => {
      let total = 0;
      qsaRows().forEach((row) => {
        total += Number(row.dataset.qty || 0);
      });
      return total;
    };

    const syncOfferTier = (totalQty) => {
      const offers = qsa('[data-dd-mm-offer]');
      const fillEl = qs('[data-dd-mm-offers-fill]');
      if (!offers.length) {
        state.activeBundlePrice = 0;
        return;
      }

      const thresholds = offers.map((el, i) => {
        const raw = el.dataset.qtyThreshold;
        return raw !== undefined && raw !== '' ? Number(raw) : i + 1;
      });

      let tier = -1;
      for (let i = offers.length - 1; i >= 0; i--) {
        if (totalQty >= thresholds[i]) {
          tier = i;
          break;
        }
      }

      state.activeBundlePrice = tier < 0 ? 0 : Number(offers[tier].dataset.bundlePrice || 0);
      state.activeOnetimeBundlePrice = tier < 0 ? 0 : Number(offers[tier].dataset.oneTimeBundlePrice || 0);
      state.activeTierEl = tier < 0 ? null : offers[tier];

      const maxIdx = offers.length - 1;
      let fillPct = 0;
      if (tier >= 0) {
        if (maxIdx <= 0 || tier >= maxIdx) {
          fillPct = 100;
        } else {
          const tierFill = (tier / maxIdx) * 100;
          const nextFill = ((tier + 1) / maxIdx) * 100;
          const progress = (totalQty - thresholds[tier]) / (thresholds[tier + 1] - thresholds[tier]);
          fillPct = tierFill + Math.min(1, Math.max(0, progress)) * (nextFill - tierFill);
        }
      }
      if (fillEl) fillEl.style.width = `${fillPct}%`;

      offers.forEach((el, i) => {
        el.classList.toggle('is-current', i === tier);
        el.classList.toggle('is-reached', tier >= 0 && i <= tier);
      });

      // Sync hardcoded free product tile: min-qty from first tier that has free_product_compare set,
      // compare price from the active tier (or that first tier as fallback)
      const freeProductTiles = qsa('[data-dd-mm-free-product-tile]');
      if (freeProductTiles.length) {
        const unlockTier = offers.find((el) => Number(el.dataset.freeProductCompare || 0) > 0);
        const priceTier = (tier >= 0 && Number(offers[tier].dataset.freeProductCompare || 0) > 0)
          ? offers[tier]
          : unlockTier;
        const minQty = unlockTier ? Number(unlockTier.dataset.qtyThreshold || 0) : 999;
        const shopCents = priceTier ? Number(priceTier.dataset.freeProductCompare || 0) : 0;
        freeProductTiles.forEach((tile) => {
          tile.dataset.ddMmGiftMinQty = minQty;
          const priceEl = tile.querySelector('[data-dd-mm-free-product-compare]');
          if (priceEl) priceEl.textContent = shopCents > 0 ? moneyShop(shopCents) : '';
        });
      }

      // Update subscription card subtitle with the active tier's frequency text
      const freqText = tier >= 0 ? (offers[tier].dataset.subscriptionFrequency || '') : '';
      qsa('[data-dd-mm-subscription-subtitle]').forEach((el) => {
        if (!el.dataset.ddMmDefaultSubtitle) el.dataset.ddMmDefaultSubtitle = el.textContent.trim();
        el.textContent = freqText || el.dataset.ddMmDefaultSubtitle;
      });
    };

    const updateRowUI = (row) => {
      const qty = Number(row.dataset.qty || 0);
      const addBtn = row.querySelector('[data-role="add"]');
      const stepper = row.querySelector('[data-role="stepper"]');
      const qtyLabel = row.querySelector('[data-role="qty-label"]');

      if (qty > 0) {
        addBtn?.classList.add('dd-mm-hidden');
        stepper?.classList.remove('dd-mm-hidden');
      } else {
        addBtn?.classList.remove('dd-mm-hidden');
        stepper?.classList.add('dd-mm-hidden');
      }

      if (qtyLabel) qtyLabel.textContent = `${qty}`;
    };

    const syncUpsellBanner = (totalQty) => {
      const banners = qsa('[data-dd-mm-upsell-banner]');
      if (!banners.length) return;

      const offers = qsa('[data-dd-mm-offer]');
      const thresholds = offers.map((el) => {
        const raw = el.dataset.qtyThreshold;
        return raw !== undefined && raw !== '' ? Number(raw) : 0;
      });

      // First tier whose threshold hasn't been reached yet
      const nextIdx = thresholds.findIndex((t) => t > 0 && totalQty < t);

      banners.forEach((banner) => {
        const prefixEl = banner.querySelector('[data-dd-mm-upsell-prefix]');
        const neededEl = banner.querySelector('[data-dd-mm-upsell-needed]');
        const connectorEl = banner.querySelector('[data-dd-mm-upsell-connector]');
        const upsellTextEl = banner.querySelector('[data-dd-mm-upsell-text]');

        if (nextIdx === -1) {
          const maxText = banner.dataset.maxText || '';
          if (maxText) {
            if (prefixEl) prefixEl.textContent = maxText;
            if (neededEl) neededEl.textContent = '';
            if (connectorEl) connectorEl.textContent = '';
            if (upsellTextEl) upsellTextEl.textContent = '';
            banner.classList.remove('dd-mm-hidden');
          } else {
            banner.classList.add('dd-mm-hidden');
          }
          return;
        }

        const upsellText = offers[nextIdx].dataset.upsellText || '';
        if (!upsellText) {
          banner.classList.add('dd-mm-hidden');
          return;
        }

        const needed = thresholds[nextIdx] - totalQty;
        if (prefixEl) prefixEl.textContent = banner.dataset.prefix || 'Add';
        if (neededEl) neededEl.textContent = needed;
        if (connectorEl) connectorEl.textContent = banner.dataset.connector || 'more';
        if (upsellTextEl) upsellTextEl.textContent = upsellText;
        banner.classList.remove('dd-mm-hidden');
      });
    };

    const recomputeTotals = () => {
      const totalQty = getTotalMixMatchQty();
      syncOfferTier(totalQty);
      syncUpsellBanner(totalQty);

      let subtotal = 0;
      let compareNormalTotal = 0;
      let subtotalSubscription = 0;
      let subtotalNormal = 0;
      const items = [];

      qsaRows().forEach((row) => {
        const qty = Number(row.dataset.qty || 0);
        const variantId = getVariantId(row);
        if (!variantId || qty < 1) return;
        subtotal += getLinePrice(row) * qty;
        compareNormalTotal += Number(row.dataset.compareNormal || 0) * qty;
        subtotalSubscription += Number(row.dataset.priceSubscription || 0) * qty;
        subtotalNormal += Number(row.dataset.priceNormal || 0) * qty;
        const line = {
          id: Number(variantId),
          quantity: qty
        };
        if (state.mode === 'subscription') {
          let sellingPlanId = null;

          // 1. Try the active tier's named Skio plan
          const tierPlanName = state.activeTierEl ? (state.activeTierEl.dataset.sellingPlanName || '') : '';
          if (tierPlanName) {
            const plans = parseSellingPlans(row.dataset.ddMmSellingPlans || '');
            sellingPlanId = plans[tierPlanName] || null;
            if (!sellingPlanId) {
              console.warn(
                '[DD Mix & Match] Selling plan "' + tierPlanName + '" not found on variant',
                variantId,
                '— falling back to first available plan. Check the plan name matches Skio exactly.'
              );
            }
          }

          // 2. Fall back to first available plan on the product
          if (!sellingPlanId) {
            const sp = row.dataset.ddMmSellingPlan;
            if (sp != null && sp !== '') {
              sellingPlanId = Number(sp) || null;
            }
          }

          if (sellingPlanId) {
            line.selling_plan = sellingPlanId;
          } else {
            console.warn(
              '[DD Mix & Match] No selling plan found for variant',
              variantId,
              '— item will be added as a one-time purchase.'
            );
          }
        }
        items.push(line);
      });

      // Bundle tier prices: subscription uses bundle_price_cents, one-time uses one_time_bundle_price_cents (falls back to sum of variant prices)
      const discountedSubscription = state.activeBundlePrice > 0 ? state.activeBundlePrice : subtotalSubscription;
      const discountedNormal = state.activeOnetimeBundlePrice > 0 ? state.activeOnetimeBundlePrice : subtotalNormal;
      const compareNormalDiscounted = compareNormalTotal;

      // ATC price follows the active mode
      const atcPriceVal = state.mode === 'subscription' ? discountedSubscription : discountedNormal;

      // ATC compare: always cross out the active tier's retail price (e.g. $174.95),
      // so the "was" price and implied savings match the offer bar in both modes.
      const activeRetailCompare = state.activeTierEl ? Number(state.activeTierEl.dataset.retailCompare || 0) : 0;
      const atcCompareVal = activeRetailCompare > atcPriceVal ? activeRetailCompare : 0;

      const atcCompareText = atcCompareVal ? moneyShop(atcCompareVal) : '';
      const atcPriceText = moneyShop(atcPriceVal);
      qsa('[data-dd-mm-atc-compare]').forEach((el) => {
        el.textContent = atcCompareText;
      });
      qsa('[data-dd-mm-atc-price]').forEach((el) => {
        el.textContent = atcPriceText;
      });

      // Purchase cards: always show both regardless of active mode
      const purchaseCompareText = discountedNormal > discountedSubscription ? moneyShop(discountedNormal) : '';
      const oneTimeCompareText = compareNormalDiscounted > discountedNormal ? moneyShop(compareNormalDiscounted) : '';
      qsa('[data-dd-mm-purchase-price]').forEach((el) => {
        el.textContent = moneyShop(discountedSubscription);
      });
      qsa('[data-dd-mm-purchase-compare-price]').forEach((el) => {
        el.textContent = purchaseCompareText;
      });
      qsa('[data-dd-mm-onetime-price]').forEach((el) => {
        el.textContent = moneyShop(discountedNormal);
      });
      qsa('[data-dd-mm-onetime-compare]').forEach((el) => {
        el.textContent = oneTimeCompareText;
      });

      const itemsJson = JSON.stringify(items);
      qsa('[data-dd-mm-atc]').forEach((btn) => {
        btn.dataset.items = itemsJson;
      });

      // Badge: savings = one-time bundle price vs subscription bundle price
      const savePct = discountedNormal > discountedSubscription
        ? Math.round((discountedNormal - discountedSubscription) / discountedNormal * 100)
        : 0;
      qsa('[data-dd-mm-purchase-badge]').forEach((badge) => {
        if (savePct > 0) {
          const template = badge.dataset.template || '';
          badge.textContent = template
            .replace(/%XX/gi, `${savePct}%`)
            .replace(/\{sub_price\}/gi, moneyShop(discountedSubscription))
            .replace(/\{compare_price\}/gi, moneyShop(discountedNormal));
          badge.classList.remove('dd-mm-hidden');
        } else {
          badge.classList.add('dd-mm-hidden');
        }
      });

      // Gift items: dim when below threshold, full opacity when reached
      qsa('[data-dd-mm-gift-min-qty]').forEach((el) => {
        el.classList.toggle('is-inactive', totalQty < Number(el.dataset.ddMmGiftMinQty || 0));
      });

      // ATC: disable when qty is 0 or doesn't exactly match a tier threshold
      const offerThresholds = qsa('[data-dd-mm-offer]').map((el) => {
        const raw = el.dataset.qtyThreshold;
        return raw !== undefined && raw !== '' ? Number(raw) : 0;
      }).filter((n) => n > 0);

      let atcOk = totalQty > 0;
      let forcedLabel = totalQty === 0 ? 'Add At Least 1 Product' : '';

      if (atcOk && offerThresholds.length > 0 && !offerThresholds.includes(totalQty)) {
        atcOk = false;
        const next = offerThresholds.find((t) => t > totalQty);
        if (next != null) {
          const needed = next - totalQty;
          forcedLabel = `Add ${needed} More Product${needed !== 1 ? 's' : ''}`;
        } else {
          const excess = totalQty - offerThresholds[offerThresholds.length - 1];
          forcedLabel = `Remove ${excess} Product${excess !== 1 ? 's' : ''}`;
        }
      }

      qsa('[data-dd-mm-atc]').forEach((btn) => {
        btn.disabled = !atcOk;
        const labelEl = btn.querySelector('[data-dd-mm-atc-label]');
        if (labelEl) labelEl.textContent = forcedLabel || btn.dataset.ddMmOriginalLabel || labelEl.textContent;
      });

      qsa('.dd-mm-purchase').forEach((el) => {
        el.classList.toggle('is-disabled', !atcOk);
      });

      const maxThreshold = offerThresholds.length > 0 ? Math.max(...offerThresholds) : 0;
      const atMaxQty = maxThreshold > 0 && totalQty >= maxThreshold;
      qsaRows().forEach((row) => {
        const plusBtn = row.querySelector('[data-role="plus"]');
        const addBtn = row.querySelector('[data-role="add"]');
        if (plusBtn) plusBtn.disabled = atMaxQty;
        if (addBtn) addBtn.disabled = atMaxQty;
      });
    };

    const syncBundlePriceLabels = () => {
      qsa('.dd-mm-offer-step-bundle-price').forEach((el) => {
        const subCents = Number(el.dataset.bundlePriceSub || 0);
        const onetimeCents = Number(el.dataset.bundlePriceOneTime || 0);
        const shopCents = state.mode === 'subscription'
          ? subCents
          : (onetimeCents > 0 ? onetimeCents : subCents);
        if (!shopCents) { el.textContent = ''; return; }
        el.textContent = moneyShop(shopCents);
      });
    };

    const syncAllPrices = () => {
      syncBundlePriceLabels();
      formatStaticShopBaseMoneyLabels();
      qsaRows().forEach((row) => updateRowUI(row));
      recomputeTotals();
    };

    const schedulePriceRefresh = () => {
      requestAnimationFrame(() => syncAllPrices());
      [150, 500].forEach((ms) => {
        setTimeout(syncAllPrices, ms);
      });
    };

    const setMode = (mode) => {
      state.mode = mode;

      // Sync checkbox cards
      qsa('[data-dd-mm-mode-checkbox]').forEach((cb) => {
        const isSubscription = mode === 'subscription';
        cb.checked = isSubscription;
        const card = cb.closest('[data-dd-mm-purchase-card]');
        if (card) card.classList.toggle('is-active', isSubscription);
        const purchaseEl = cb.closest('.dd-mm-purchase');
        if (purchaseEl) {
          const subtitleEl = purchaseEl.querySelector('[data-dd-mm-subscription-subtitle]');
          if (subtitleEl) {
            subtitleEl.textContent = isSubscription
              ? (subtitleEl.dataset.ddMmDefaultSubtitle || subtitleEl.textContent)
              : (card ? card.dataset.ddMmOnetimeSubtitle || '' : '');
          }
        }
      });

      // Backward-compat: keep any legacy mode buttons in sync
      qsa('[data-dd-mm-mode-btn]').forEach((btn) => {
        const active = btn.dataset.mode === mode;
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        btn.classList.toggle('is-active', active);
      });

      // Notify block-level scripts (offer titles, gifts heading)
      root.dispatchEvent(new CustomEvent('dd-mm:mode', { detail: { mode }, bubbles: false }));

      syncBundlePriceLabels();
      qsaRows().forEach((row) => updateRowUI(row));
      recomputeTotals();
    };

    // Checkbox toggle
    qsa('[data-dd-mm-mode-checkbox]').forEach((cb) => {
      // Store the one-time subtitle from the schema setting rendered onto the card
      const card = cb.closest('[data-dd-mm-purchase-card]');
      if (card) {
        const subtitleEl = cb.closest('.dd-mm-purchase') && cb.closest('.dd-mm-purchase').querySelector('[data-dd-mm-subscription-subtitle]');
        if (subtitleEl && !subtitleEl.dataset.ddMmDefaultSubtitle) {
          subtitleEl.dataset.ddMmDefaultSubtitle = subtitleEl.textContent.trim();
        }
      }
      cb.addEventListener('change', () => setMode(cb.checked ? 'subscription' : 'one_time'));
    });

    // Legacy mode buttons
    qsa('[data-dd-mm-mode-btn]').forEach((btn) => {
      btn.addEventListener('click', () => setMode(btn.dataset.mode));
    });

    qsaRows().forEach((row) => {
      row.dataset.qty = row.dataset.defaultQty || '0';
      updateRowUI(row);
    });

    root.addEventListener('click', (e) => {
      const rawTarget = e.target;
      const clickEl =
        rawTarget && rawTarget.nodeType === Node.ELEMENT_NODE
          ? rawTarget
          : rawTarget && rawTarget.parentElement;
      if (!(clickEl instanceof Element)) return;

      const row = clickEl.closest('[data-dd-mm-row]');
      if (!row || !mixMatchRowsScope.contains(row)) return;

      const addBtn = row.querySelector('[data-role="add"]');
      const minusBtn = row.querySelector('[data-role="minus"]');
      const plusBtn = row.querySelector('[data-role="plus"]');

      if (addBtn && addBtn.contains(clickEl)) {
        row.dataset.qty = '1';
        updateRowUI(row);
        recomputeTotals();
        return;
      }
      if (minusBtn && minusBtn.contains(clickEl)) {
        const current = Number(row.dataset.qty || 0);
        row.dataset.qty = String(Math.max(0, current - 1));
        updateRowUI(row);
        recomputeTotals();
        return;
      }
      if (plusBtn && plusBtn.contains(clickEl)) {
        const current = Number(row.dataset.qty || 0);
        row.dataset.qty = String(current + 1);
        updateRowUI(row);
        recomputeTotals();
      }
    });

    qsa('[data-dd-mm-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.index || 0);
        state.activeGalleryIndex = index;
        qsa('[data-dd-mm-gallery-main]').forEach((slide) => {
          const active = Number(slide.dataset.index || 0) === index;
          slide.classList.toggle('is-active', active);
        });
        qsa('[data-dd-mm-gallery-thumb]').forEach((item) => {
          const active = Number(item.dataset.index || 0) === index;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-current', active ? 'true' : 'false');
        });
      });
    });

    qsa('[data-dd-mm-gallery-prev]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const total = qsa('[data-dd-mm-gallery-main]').length;
        if (!total) return;
        state.activeGalleryIndex = (state.activeGalleryIndex - 1 + total) % total;
        qsa('[data-dd-mm-gallery-thumb]')[state.activeGalleryIndex]?.click();
      });
    });

    qsa('[data-dd-mm-gallery-next]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const total = qsa('[data-dd-mm-gallery-main]').length;
        if (!total) return;
        state.activeGalleryIndex = (state.activeGalleryIndex + 1) % total;
        qsa('[data-dd-mm-gallery-thumb]')[state.activeGalleryIndex]?.click();
      });
    });

    qsa('[data-dd-mm-countdown]').forEach((timer) => {
      const endAtRaw = timer.dataset.endAt;
      if (!endAtRaw) return;
      const endAt = new Date(endAtRaw);
      if (Number.isNaN(endAt.getTime())) return;

      const dayEl = timer.querySelector('[data-role="days"]');
      const hourEl = timer.querySelector('[data-role="hours"]');
      const minEl = timer.querySelector('[data-role="minutes"]');
      const secEl = timer.querySelector('[data-role="seconds"]');

      const tick = () => {
        const diff = Math.max(0, endAt.getTime() - Date.now());
        const days = Math.floor(diff / 86400000);
        const hours = Math.floor((diff % 86400000) / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);

        if (dayEl) dayEl.textContent = String(days).padStart(2, '0');
        if (hourEl) hourEl.textContent = String(hours).padStart(2, '0');
        if (minEl) minEl.textContent = String(minutes).padStart(2, '0');
        if (secEl) secEl.textContent = String(seconds).padStart(2, '0');
      };

      tick();
      ddMmIntervals.get(root).push(setInterval(tick, 1000));
    });

    qsa('[data-dd-mm-atc]').forEach((button) => {
      button.addEventListener('click', async (event) => {
        const itemsRaw = button.dataset.items;
        if (!itemsRaw) return;
        const items = JSON.parse(itemsRaw);
        if (!Array.isArray(items) || !items.length) return;

        const labelEl = button.querySelector('[data-dd-mm-atc-label]');
        const originalLabel = button.dataset.ddMmOriginalLabel || (labelEl ? labelEl.textContent : '');

        button.disabled = true;
        if (labelEl) labelEl.textContent = 'Adding...';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) {
            let msg = 'Unable to add to cart';
            try { msg = (await response.json()).description || msg; } catch (_) {}
            throw new Error(msg);
          }
          if (labelEl) labelEl.textContent = 'Added';
          // Notify the theme the cart changed (updates header count, mini-cart, etc.)
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          if (typeof openCart === 'function') {
            openCart();
          } else if (document.querySelector('#miniCart')) {
            document.querySelector('#miniCart').showModal();
          }
        } catch (error) {
          if (labelEl) labelEl.textContent = error.message || 'Try again';
        } finally {
          setTimeout(() => {
            button.disabled = false;
            if (labelEl) labelEl.textContent = originalLabel;
          }, 1200);
        }
      });
    });

    // Store original ATC labels before any state overrides
    qsa('[data-dd-mm-atc]').forEach((btn) => {
      const labelEl = btn.querySelector('[data-dd-mm-atc-label]');
      if (labelEl) btn.dataset.ddMmOriginalLabel = labelEl.textContent.trim();
    });

    setMode('subscription');
    qsa('[data-dd-mm-gallery-thumb]')[0]?.click();

    ddMmSyncFns.set(root, syncAllPrices);
    schedulePriceRefresh();
    moveSocialProof(root);
    }

    function bootDdMixMatch() {
      document.querySelectorAll('.dd-mm-section').forEach(initDdMixMatch);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootDdMixMatch);
    } else {
      bootDdMixMatch();
    }

    window.addEventListener('load', refreshAllDdMixMatchSections);
    document.addEventListener('shopify:section:load', function (ev) {
      const t = ev.target;
      if (t && typeof t.querySelectorAll === 'function') {
        t.querySelectorAll('.dd-mm-section').forEach(function (el) {
          // Clear inited flag so block additions in the theme editor trigger a full re-init
          delete el.dataset.ddMmInited;
          const intervals = ddMmIntervals.get(el);
          if (intervals) intervals.forEach(clearInterval);
          ddMmIntervals.delete(el);
          initDdMixMatch(el);
        });
      }
      refreshAllDdMixMatchSections();
    });

    document.addEventListener('shopify:section:unload', function (ev) {
      const t = ev.target;
      if (t && typeof t.querySelectorAll === 'function') {
        t.querySelectorAll('.dd-mm-section').forEach(function (el) {
          const intervals = ddMmIntervals.get(el);
          if (intervals) intervals.forEach(clearInterval);
          ddMmIntervals.delete(el);
          delete el.dataset.ddMmInited;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
